import { SuitUIButton } from '../../../SuitUIButton';

interface FormFooterProps {
    onContinue: () => void;
    onSave: () => void;
    onPreview: () => void;
    onGoBack: () => void;
    steps: number;
    activeStep: number;
    disabled: boolean;
}

const FormFooter = ({
    onContinue,
    onSave,
    onPreview,
    onGoBack,
    steps,
    activeStep,
    disabled
}: FormFooterProps) => {
    return (
        <>
            {activeStep === 0 && activeStep !== steps - 1 ? (
                <SuitUIButton
                    text='Continue'
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                        onContinue();
                    }}
                    fullWidth
                    style='mt-[40px]'
                />
            ) : activeStep === steps - 1 ? (
                <div>
                    <div className='flex gap-[16px] items-center justify-end mt-[40px] lg:mb-0'>
                        <SuitUIButton
                            text='Preview'
                            onClick={() => {
                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                                onPreview();
                            }}
                            invert
                            fullWidth
                            style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
                        />

                        <SuitUIButton
                            text='Save'
                            onClick={onSave}
                            fullWidth
                            disabled={disabled}
                        />
                    </div>
                    {activeStep === steps - 1 && steps !== 1 && (
                        <SuitUIButton
                            text='Back'
                            onClick={() => {
                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                                onGoBack();
                            }}
                            invert
                            fullWidth
                            style='mt-4 text-paleSky'
                        />
                    )}
                </div>
            ) : (
                <div className='flex gap-[16px] items-center justify-end mt-[40px] lg:mb-0'>
                    <SuitUIButton
                        text='Back'
                        onClick={() => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                            onGoBack();
                        }}
                        invert
                        fullWidth
                        style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
                    />

                    <SuitUIButton
                        text='Continue'
                        onClick={() => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                            onContinue();
                        }}
                        fullWidth
                    />
                </div>
            )}
        </>
    );
};

export default FormFooter;
